import React from "react"
import { graphql } from "gatsby"

import { QueryFragments } from "../GraphQl/queryFragments"

import { PageMeta } from "../components/pageMeta"
import { PortableTextBlock } from "../components/sanity/portableTextBlock"

import { RecentPosts } from "../components/blog/recentPosts"

const BlogTemplate = ({ data: { post } }) => {
  const { meta, _rawPost } = post
  return (
    <>
      <PageMeta {...meta} />
      <div className="grid grid-cols-14 mt-64 md:mt-80 mb-24">
        <div className="prose md:prose-lg max-w-none col-start-2 col-end-14 md:col-start-4 md:col-end-12">
          <PortableTextBlock text={_rawPost} />
        </div>
        <div className="col-start-2 col-end-14 md:col-start-3 md:col-end-13">
          <RecentPosts />
        </div>
      </div>
    </>
  )
}

export default BlogTemplate

export const pageQuery = graphql`
  query blogPostQuery($slug: String!) {
    post: sanityPost(slug: { current: { eq: $slug } }) {
      title
      meta {
        ...MetaCardFields
      }
      _rawPost(resolveReferences: { maxDepth: 10 })
    }
  }
`
